module.exports = __webpack_public_path__ + "static/media/42.814eaece.avif";